<div
	*ngIf="forceDisplay || (!inComponent && !(isAuthenticatedAndReady$ | async) && hasRequestsInProgress$ | async)"
	class="full-screen-loader"
>
	<mat-spinner color="primary" [diameter]="100"></mat-spinner>
</div>

<div *ngIf="inComponent && hasRequestsInProgress$ | async" class="in-component-loader">
	<mat-spinner color="primary" [diameter]="50"></mat-spinner>
</div>
